"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../../build/components");
var _location = require("../../utils/location");
var _plan = require("../../api/accessors/plan");
var _api = require("../../api");
var _response = require("../../utils/response");
var _stripe = require("../../stripe");
var _hooks = require("../../hooks");
var _style = _interopRequireDefault(require("./style"));
var _SubscribeFormSkeleton = require("./SubscribeFormSkeleton");
var _subscription = require("../../api/accessors/subscription");
var _stripeAccount = require("../../api/accessors/stripeAccount");
var _paymentMethod = require("../../api/accessors/paymentMethod");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SubscribeForm = _ref => {
  let {
    onClose,
    showTitle = true,
    expiresAt,
    customer,
    ...props
  } = _ref;
  const {
    locale,
    stripePublicKey,
    brandId
  } = (0, _hooks.useConfig)();
  const classes = (0, _style.default)(props);
  const subscriptions = (0, _stripeAccount.getSubscriptions)(customer);
  const initialSubscription = Array.isArray(subscriptions) && subscriptions.length === 1 ? subscriptions[0] : null;
  const initialPlan = (0, _subscription.getPlan)(initialSubscription);
  const stripePromise = (0, _hooks.useStripePromise)(stripePublicKey);
  const {
    data: popups,
    fetching: fetchingPopups,
    fetchingError: fetchingPopupsError
  } = (0, _hooks.useFetchEffect)({
    initialDataState: [],
    defaultDataState: [],
    apiFetchFunction: () => (0, _api.fetchPopups)({
      brandId
    })
  });
  const preferredPopup = popups.find(_ref2 => {
    let {
      language,
      is_active
    } = _ref2;
    return language === locale && is_active;
  });
  const fallbackPopup = popups.find(_ref3 => {
    let {
      is_active
    } = _ref3;
    return is_active;
  });
  const popup = preferredPopup || fallbackPopup;
  const [hasPaymentSucceeded, setPaymentSucceeded] = (0, _react.useState)(false);
  const [plan, setPlan] = (0, _react.useState)(initialPlan || null);
  const [subscription, setSubscription] = (0, _react.useState)(null);
  const [paymentMethod, setPaymentMethod] = (0, _react.useState)(null);
  const [confirmRequestError, setConfirmRequestError] = (0, _react.useState)(null);
  const isAccountPage = (0, _location.getUrlParam)('_action') === 'plugin.recurrent_account';
  const onPlanChange = planOption => {
    setPlan(planOption);
  };
  const onOrderConfirm = async () => {
    setConfirmRequestError(null);
    const itemToUpdate = initialSubscription && initialSubscription.items?.data?.find(item => item.plan && item.plan.id === (0, _plan.getId)((0, _subscription.getPlan)(initialSubscription)));
    const regularCustomerWithExistedSubscription = /^cus_/.test((0, _paymentMethod.getId)(customer)) && !!initialPlan && !!itemToUpdate;
    const apiRequest = regularCustomerWithExistedSubscription ? _api.updateSubscription : _api.createSubscription;
    const requestData = regularCustomerWithExistedSubscription ? [(0, _subscription.getId)(initialSubscription), {
      items: [{
        id: itemToUpdate.id,
        plan: (0, _plan.getId)(plan)
      }]
    }] : [{
      internalData: {},
      items: [{
        plan: (0, _plan.getId)(plan)
      }]
    }];
    const [error, response] = await apiRequest(...requestData);
    if (!error && response) {
      setSubscription(response);
    } else {
      setConfirmRequestError(error);
    }
  };
  const onPaymentMethodFormSuccess = async incomingSetupIntent => {
    setPaymentMethod(incomingSetupIntent);
    await onOrderConfirm();
  };
  const onSubscribedAndClosed = () => {
    if (isAccountPage) {
      window.location.reload();
    }
    onClose();
  };
  const handleActivationFormSubmit = async setupIntent => {
    await onPaymentMethodFormSuccess(setupIntent);
    setPaymentSucceeded(true);
  };
  const getModal = () => {
    if (hasPaymentSucceeded) {
      return /*#__PURE__*/_react.default.createElement(_components.OrderOverview, {
        plan: plan,
        subscription: subscription,
        paymentMethod: paymentMethod,
        onClose: onSubscribedAndClosed,
        requestError: confirmRequestError
      });
    }
    if (fetchingPopupsError) {
      return /*#__PURE__*/_react.default.createElement(_components.AlertMessage, {
        text: (0, _response.getErrorMessage)(fetchingPopupsError)
      });
    }
    return /*#__PURE__*/_react.default.createElement(_components.SubscriptionActivationForm, {
      config: popup,
      maxWidth: "100%",
      hasPaymentSucceeded: hasPaymentSucceeded,
      onSubmit: handleActivationFormSubmit,
      onClose: onClose,
      defaultSelectedPlan: plan,
      onPlanChange: onPlanChange,
      expiresAt: expiresAt,
      customer: customer,
      disabled: !plan
    });
  };
  if (fetchingPopups) {
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      py: 2
    }, /*#__PURE__*/_react.default.createElement(_SubscribeFormSkeleton.SubscribeFormSkeleton, null));
  }
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.root
  }, showTitle && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    paragraph: true,
    variant: "h5",
    component: "h4"
  }, /*#__PURE__*/_react.default.createElement(_components.Translated, {
    id: "membership"
  })), /*#__PURE__*/_react.default.createElement(_stripe.Elements, {
    stripe: stripePromise
  }, getModal()));
};
var _default = exports.default = SubscribeForm;